/* eslint-disable camelcase */
import jwt from "jsonwebtoken";

export interface tokenUser {
  cpf: string;
  email: string;
  id_acesso: string;
  id_ome: number;
  base: string;
  iat: number;
  exp: number;
  sistemas: [];
}

export function decodeToken(token: string): tokenUser {
  const fullToken = token;
  // const parts = fullToken.split(' ')

  const usuario = jwt.decode(fullToken) as tokenUser;

  return usuario;
}
